import React from 'react';

const FAQSchema = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is process serving?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Process serving is the legal procedure of delivering court documents to individuals involved in legal proceedings. It ensures all parties are officially notified of legal actions against them, which is required by law before court proceedings can continue."
        }
      },
      {
        "@type": "Question",
        "name": "How much does process serving cost in California?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Process serving costs depend on the service level (Routine, Priority, Same Day, or On-Demand), location, and urgency. Email your case specifics to quote@legaldocspecialist.com for a quote."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide same-day process serving?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we offer same-day process serving throughout California for urgent legal matters. Email your case specifics to quote@legaldocspecialist.com for a quote on same-day service."
        }
      },
      {
        "@type": "Question",
        "name": "What proof of service do you provide?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We provide detailed proof of service documents with GPS data, timestamps, and complete service details as required by law. You'll receive regular updates via email and phone throughout the process."
        }
      },
      {
        "@type": "Question",
        "name": "Are your process servers registered and bonded?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, all our process servers are properly registered and bonded in accordance with California law. We maintain full insurance coverage for your protection and peace of mind."
        }
      },
      {
        "@type": "Question",
        "name": "What areas do you serve?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We serve all of California with dedicated coverage in 21 cities including the Coachella Valley, Hi-Desert region, and Central Riverside County. We also provide services statewide through our network of registered process servers."
        }
      },
      {
        "@type": "Question",
        "name": "How do I track my service request?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "After placing your order, you'll receive regular updates via email. We provide detailed affidavits of service with GPS data when service is completed. You can also email support@legaldocspecialist.com anytime for status updates."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer court filing services?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we provide comprehensive court filing services including e-filing and traditional filing for all California courts. We offer same-day filing for urgent matters and handle all document types."
        }
      }
    ]
  };

  React.useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent === JSON.stringify(faqSchema)) {
        existingScript.remove();
      }
    };
  }, []);

  return null; // This component only adds schema markup
};

export default FAQSchema;